<script lang="ts">
  import AnimatedSection from '$components/AnimatedSection.svelte';
  import { m } from '$lib/paraglide/messages.js';
  import { localizeHref } from '$lib/paraglide/runtime.js';
  import type { Snippet } from 'svelte';

  interface Props {
    children: Snippet;
    label?: string;
    description?: string;
    centered?: boolean;
    minHeight?: string;
    className?: string;
  }

  let {
    children,
    label = '',
    description = '',
    centered = false,
    minHeight = '',
    className = '',
  }: Props = $props();
</script>

<section
  class="bg-parchment px-[4vw] pt-24 pb-[2vh] md:pt-20 md:pb-0 flex items-center {className} {minHeight ? '' : 'min-h-[34vh] md:min-h-[40vh]'}"
  style={minHeight ? `min-height: ${minHeight};` : undefined}
>
  <div class="max-w-[1400px] mx-auto w-full {centered ? 'text-center' : ''}">
    <AnimatedSection direction="up" delay={0.1}>
      {#if label}
        <div class="font-accent uppercase text-[0.65rem] tracking-[0.12em] text-taupe mb-4">
          <a href={localizeHref('/')} class="hover:text-charcoal transition-colors">{m.breadcrumb_home()}</a>
          <span class="mx-2">/</span>
          <span>{label}</span>
        </div>
      {/if}
      {@render children()}
      {#if description}
        <p class="font-body text-[1rem] md:text-[1.05rem] leading-[1.6] text-taupe max-w-[560px] mt-[2vh] {centered ? 'mx-auto' : ''}">
          {description}
        </p>
      {/if}
    </AnimatedSection>
  </div>
</section>
